import { useContext } from 'react'
import { authContext, type AuthContextValue } from './context'

export function useAuth(): AuthContextValue {
  const context = useContext(authContext)
  if (!context) throw new Error('useAuth must be used inside AuthProvider')
  return context
}
